import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { IconSearch } from '@nxsys/components/AppIconSvg';
import { stripLeadingWhitespace } from '@nxsys/utils/textUtils';
import { StyledInputSearch } from './index.styled';

type AppInputProps = {
  [x: string]: any;
};

const AppInput: React.FC<AppInputProps> = ({
  onChange,
  ...rest
}: AppInputProps) => {
  const { messages } = useIntl();
  const [searchValue, setSearchValue] = useState('');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Pasted text is trimmed on both ends; typed input only strips leading
    // spaces so users can still type spaces between words
    const isPaste =
      (e.nativeEvent as InputEvent).inputType === 'insertFromPaste';
    const value = isPaste
      ? e.target.value.trim()
      : stripLeadingWhitespace(e.target.value);
    const capitalizedValue = value.charAt(0).toUpperCase() + value.slice(1);

    // Create a new event with the capitalized value
    const newEvent = {
      ...e,
      target: {
        ...e.target,
        value: capitalizedValue,
      },
    };
    setSearchValue(capitalizedValue);

    // Call the original onChange if provided
    if (onChange) {
      onChange(newEvent);
    }
  };

  return (
    <StyledInputSearch
      className="search-input"
      prefix={<IconSearch />}
      placeholder={messages['common.search'] as string}
      onChange={handleChange}
      value={searchValue}
      {...rest}
    />
  );
};
export default AppInput;
